// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonEditDigitalFilterCustom_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.98729 1.99992H16.3928L18.3801 0H0V23.999H23.999V5.81115L21.8602 7.81107V21.9991H1.98729V1.99992Z" class="svg-bg"/>
  <path d="M22.2424 4.59805 21.8602 4.21333V4.21135L19.6627 1.99992H19.6607L19.432 1.76973 19.433 1.76874 19.432 1.7678 21.1886.000102903 23.999 2.82841 23.8475 2.98095V2.98284L22.2424 4.59805ZM5.3798 18.7377 6.78502 14.4952 18.0268 3.18195 20.8373 6.01027 9.59547 17.3235 5.3798 18.7377Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.76771 19.6949L6.99994 24.9982L12.3032 23.2305L26.4454 9.08833L22.9099 5.55278L8.76771 19.6949ZM24.3009 4.16173L26.4454 2.01724L29.9809 5.5528L27.8596 7.67412L24.3009 4.16173Z" class="svg-bg"/>
  <path d="M21.6361 4H3V29H28V10.364L30 8.36403V31H1V2H23.6361L21.6361 4Z" class="svg-bg"/>
  <path d="M28 7.53562V7.53371L29.9799 5.55379L29.9809 5.55473L28 7.53562Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonEditDigitalFilterCustom is a generated icon component.
 */
let IconCommonEditDigitalFilterCustom = IconCommonEditDigitalFilterCustom_1 = class IconCommonEditDigitalFilterCustom extends IconBaseElement {
    render() {
        return html `${IconCommonEditDigitalFilterCustom_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonEditDigitalFilterCustom.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconCommonEditDigitalFilterCustom = IconCommonEditDigitalFilterCustom_1 = __decorate([
    customElement('zui-icon-common-edit-digital-filter-custom')
], IconCommonEditDigitalFilterCustom);
export { IconCommonEditDigitalFilterCustom };
